export const ALLOWED_CONTENT_BRIEF_STATUS_NAMES_FOR_CLIENT_COLLABORATOR = ['collaborating']
export const ALLOWED_URL_STATUS_NAMES_CALENDAR_PLANNER = ['proposed', 'planned', 'explored', 'published']
export const ALLOWED_BRIEF_STATUSES_TO_NAVIGATE_FROM = ['collaborating', 'completed', 'approved']
export const ALLOWED_URL_STATUS_NAMES_CALENDAR = ['proposed', 'planned', 'published']
